import React, { useState, useEffect } from 'react';
import axios from 'axios';
import LoginLogo from '../../Assets/images/Frame 39059 1.png';
import LoginImg from '../../Assets/images/Loginimage-woman-smile-happy-joy 1.png';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import apiClient from '../../Api/apiClient';
import { useLocation } from 'react-router-dom';
const ForgotPassword = () => {
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const location = useLocation();
  const { forgotFromAffiliator } = location.state || {};
  const [phoneNumber, setPhoneNumber] = useState('');
  const [countryCode, setCountryCode] = useState('88');

  // Update localStorage whenever state changes
  useEffect(() => {
    localStorage.setItem('phoneNumber', phoneNumber);
  }, [phoneNumber]);

  // Function to send forgot password OTP
  const handleForgotPassOtp = async () => {
    try {
      let url = '/auth/user/forgot-password';
      if (forgotFromAffiliator) {
        url = '/auth/affiliator/forgot-password';
      }
      const response = await apiClient.post(
        // '/auth/user/forgot-password',
        url,
        { phone: phoneNumber },
        { withCredentials: true }
      );

      // Show success alert
      const succesMessage = response.data.message;
      Swal.fire({
        title: 'OTP Sent!',
        // text: 'Please check your OTP.',
        text: succesMessage,
        customClass: {
          popup: 'w-72 h-auto p-3',
          title: 'text-lg',
          content: 'text-xs',
          confirmButton: 'bg-headerBtn text-white px-4 py-1 text-sm rounded-md',
        },
      });
      navigate('/forgot-password-OTP', {
        // state: { phone: `${countryCode}${phoneNumber}` },
        state: {
          phone: phoneNumber,
          forgotFromAffiliator: forgotFromAffiliator,
        },
      });
    }
     catch (error) {
      console.error('Error:', error);
      const errorMessage = error.response?.data?.message;
      Swal.fire({
        // icon: 'error',
        title: 'Error!',
        // text: 'Failed to send. Please try again.',
        text: errorMessage,
        customClass: {
          popup: 'w-72 h-auto p-3',
          title: 'text-lg',
          content: 'text-xs',
          confirmButton: 'bg-headerBtn text-white px-4 py-1 text-sm rounded-md',
        },
      });
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!phoneNumber) newErrors.username = 'Mobile number is required';
    return newErrors;
  };

  const handleSignUpKey = e => {
    if (e.key === 'Enter') handleForgotPassOtp();
  };

  return (
    <div className="flex bg-EntryBG items-center justify-center min-h-screen md:py-16 py-24 md:mt-10 mt-16 px-2 ">
      <div className="bg-white p-10 items-center justify-center flex flex-col lg:flex-row gap-10 shadow-xl rounded-xl">
        {/* left section */}
        <div>
          <img
            src={LoginLogo}
            alt="LoginLogo"
            className=" h-10 lg:h-16 mb-0 md:pl-8 lg:mb-0"
          />
          <img src={LoginImg} alt="LoginImg" className="md:h-40 h-32 " />
        </div>

        {/* right section */}
        <div>
          <h2 className="text-xl text-center lg:text-2xl font-semibold mt-1 mb-4 heading">
            Forget Password
          </h2>

          <div className="w-full lg:w-[400px] space-y-4 mt-2">
            <div className="flex flex-col space-y-4">
              {/* <input
                type="text"
                placeholder="+880 Mobile Number"
                className="border border-gray-300 rounded-md py-2 px-4 w-full"
                value={phoneNumber}
                onChange={e => setPhoneNumber(e.target.value)}
                onKeyDown={handleSignUpKey}
              /> */}
              <div className="flex space-x-1">
                {/* <select
                  className="border text-xs border-gray-300 rounded-md py-2 px-1 w-24"
                  value={countryCode}
                  onChange={e => setCountryCode(e.target.value)}
                >
                  <option value="88">+88(Ban)</option>
                  <option value="1">+1(USA/Canada)</option>
                  <option value="44">+44(UK)</option>
                  <option value="91">+91(India)</option>
                  <option value="61">+61(Aust)</option>
                  <option value="33">+33(France)</option>
                  <option value="49">+49(Germany)</option>
                  <option value="39">+39(Italy)</option>
                  <option value="81">+81(Japan)</option>
                  <option value="7">+7(Russia)</option>
                  <option value="86">+86(China)</option>
                  <option value="34">+34(Spain)</option>
                  <option value="55">+55(Brazil)</option>
                  <option value="27">+27(SA)</option>
                  <option value="52">+52(Mexico)</option>
                  <option value="20">+20(Egypt)</option>
                  <option value="45">+45(Denmark)</option>
                  <option value="31">+31(Netherlands)</option>
                  <option value="90">+90(Turkey)</option>
                  <option value="63">+63(Philippines)</option>
                  <option value="66">+66(Thailand)</option>
                  <option value="32">+32(Belgium)</option>
                  <option value="56">+56(Chile)</option>
                  <option value="46">+46(Sweden)</option>
                  <option value="351">+351(Portugal)</option>
                  <option value="965">+965(Kuwait)</option>
                  <option value="971">+971(UAE)</option>
                  <option value="30">+30(Greece)</option>
                  <option value="972">+972(Israel)</option>
                  <option value="964">+964(Iraq)</option>
                  <option value="256">+256(Uganda)</option>
                </select> */}
                <input
                  type="text"
                  placeholder="Email or Phone with country code"
                  className="border text-xs border-gray-300 rounded-md py-2 px-2 w-full"
                  value={phoneNumber}
                  onChange={e => setPhoneNumber(e.target.value)}
                  onKeyDown={handleSignUpKey}
                />
              </div>
              {errors.username && (
                <p className="text-red-500 text-xs mb-0 -mt-2">
                  {errors.username}
                </p>
              )}
            </div>

            <button
              onClick={handleForgotPassOtp}
              className="w-full bg-EntryBG text-white py-2 px-6 hover:bg-btnHover mb-2 mt-2 rounded-2xl"
            >
              Send
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
